export const SIDEBAR = 'post_sidebar';
export const POST_LIST_ITEM_RECENT_ACTIVITY = 'post_list_item_recent_activity';
